import { styled, useTheme } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { RootState } from 'redux/store'
import { ASIDE_WIDTH, DRAWER_WIDTH, HEADER_HEIGHT } from 'utils/customizedTheme'
import useMediaQuery from '@mui/material/useMediaQuery'
import { FC } from 'react'

interface IProps {
  userToken: string
  children: any
}

const Main: FC<IProps> = ({ children, userToken }) => {
  const theme = useTheme()
  const md = useMediaQuery(theme.breakpoints.up('md'))
  const lg = useMediaQuery(theme.breakpoints.up('lg'))
  const xl = useMediaQuery(theme.breakpoints.up('xl'))
  const openNavigation = useSelector((state: RootState) => state.theme.openNavigation)
  const openSidebar = useSelector((state: RootState) => state.theme.openSidebar)

  return (
    <Page openSidebar={openSidebar} openNavigation={openNavigation} md={md} lg={lg} xl={xl} userToken={!!userToken}>
      {children}
    </Page>
  )
}
export default Main

const Page = styled('main', {
  shouldForwardProp: (prop) =>
    prop !== 'openSidebar' && prop !== 'openNavigation' && prop !== 'md' && prop !== 'lg' && prop !== 'xl' && prop !== 'userToken',
})<{
  openSidebar?: boolean
  openNavigation?: boolean
  md?: boolean
  lg?: boolean
  xl?: boolean
  userToken: boolean
}>(({ theme, openSidebar, openNavigation, md, lg, xl, userToken }) => ({
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: 0,
  marginRight: 0,
  marginTop: userToken ? HEADER_HEIGHT : 0,
  ...(openNavigation && {
    marginLeft: `${openNavigation && xl && userToken ? DRAWER_WIDTH : 0}px`,
  }),
  ...(openSidebar && {
    marginRight: `${openSidebar && md && userToken  ? ASIDE_WIDTH : 0}px`,
  }),
}))
